export interface INotificationsDrawerProps {
  openDrawer: boolean;
  onCloseDrawer(): void;
}

export enum NotificationsTabsEnum {
  UNREAD = 'tab-unread',
  ALL = 'tab-all',
}
